import { jsx as d } from "react/jsx-runtime";
import { c as y } from "../index-DpeO8ABv.js";
import { c as a } from "../clsx-OuTLNxxd.js";
import "../Card.css?__remix_sideEffect__";const r = "320px",m = "600px",g = "1025px",h = "_isVisuallyHidden_pmijb_52",f = "_card_pmijb_64",p = "_primary_pmijb_78",b = "_secondary_pmijb_82",_ = "_shouldCenter_pmijb_110",i = {
    mobile: r,
    "mobile-wide": "480px",
    tablet: m,
    "tablet-wide": "800px",
    desktop: g,
    "desktop-mid": "1281px",
    "desktop-large": "1360px",
    "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
    "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
    "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
    "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
    "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
    "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
    "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
    "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
    "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
    "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
    "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
    isVisuallyHidden: h,
    card: f,
    primary: p,
    secondary: b,
    "padding-s": "_padding-s_pmijb_86",
    "padding-m": "_padding-m_pmijb_90",
    "padding-l": "_padding-l_pmijb_94",
    "borderRadius-s": "_borderRadius-s_pmijb_98",
    "borderRadius-m": "_borderRadius-m_pmijb_102",
    "borderRadius-l": "_borderRadius-l_pmijb_106",
    shouldCenter: _
  },H = y(i.card, {
    variants: {
      variant: {
        primary: i.primary,
        secondary: i.secondary
      }
    },
    defaultVariants: {
      variant: "primary"
    }
  }),j = ({
    children: n,
    padding: e,
    borderRadius: t = "m",
    height: x,
    shouldCenter: o,
    variant: s,
    className: l,
    ...c
  }) => /* @__PURE__ */d(
    "div",
    {
      style: x ? { "--cxy-card-height": x } : {},
      className: a(
        H({ variant: s }),
        {
          [i[`padding-${e}`]]: e && typeof e == "string",
          [i.shouldCenter]: o,
          [i[`borderRadius-${t}`]]: t
        },
        l
      ),
      ...c,
      children: n
    }
  );
export {
  j as Card };